/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoutineResponse } from '../../models/routine-response';

export interface GetRoutine$Params {
  routine_id: string;
}

export function getRoutine(http: HttpClient, rootUrl: string, params: GetRoutine$Params, context?: HttpContext): Observable<StrictHttpResponse<RoutineResponse>> {
  const rb = new RequestBuilder(rootUrl, getRoutine.PATH, 'get');
  if (params) {
    rb.path('routine_id', params.routine_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoutineResponse>;
    })
  );
}

getRoutine.PATH = '/routines/{routine_id}';
